import { render, staticRenderFns } from "./SiteBookingSettingSet.vue?vue&type=template&id=33701d33"
import script from "./SiteBookingSettingSet.vue?vue&type=script&lang=js"
export * from "./SiteBookingSettingSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports